module.exports = __webpack_public_path__ + "img/luechai_logo_tekst.0260a92b.png";